import { put, takeLatest, call, spawn } from 'redux-saga/effects';
import { indicatorsActions } from '../../../application/actions/indicators';

import api from '../../api';

const apiIndicators = api(process.env.REACT_APP_INDICATORS_API);

export function* fetchIndicators(action) {
  try {
    const { data } = yield call(apiIndicators.get, 'v1/consultar', action.payload);

    if (data) yield put(indicatorsActions.fetchIndicatorsSuccess({data}));
    else yield put(indicatorsActions.fetchIndicatorsError());
  } catch (err) {
    yield put(indicatorsActions.fetchIndicatorsError());
  }
}

export function* watchFetchIndicators() {
  yield takeLatest(indicatorsActions.fetchIndicators.type, fetchIndicators);
}

export default function* indicatorsSaga() {
  yield spawn(watchFetchIndicators);
}
